import React from "react";
import { EmeraldButton } from "@/components/Bits";

const NotFound = () => (
  <div className="min-h-[60vh] bg-ess-paper flex items-center" data-testid="page-not-found">
    <div className="ess-container text-center">
      <p className="ess-overline">404</p>
      <h1 className="font-display text-6xl md:text-7xl text-ess-emerald mt-3">
        This page has exited.
      </h1>
      <p className="text-ess-slate mt-4">Let's get you back to the strategy.</p>
      <EmeraldButton as="link" to="/" className="mt-8">
        Return Home
      </EmeraldButton>
    </div>
  </div>
);

export default NotFound;
